import { Unternehmensthema } from "@/models/UnternehmensthemenModels"

export type State = {
  unternehmensthemen: Array<Unternehmensthema>
}

export const state: State = {
  unternehmensthemen: sessionStorage.getItem("unternehmensthemen") != null ? JSON.parse(sessionStorage.unternehmensthemen) : new Array<Unternehmensthema>(),
}
